import { PageTitle } from '../../../components/StyledComponents';
import { HeaderContainer } from '../StyledComponents';

const Header = () => {
  return (
    <HeaderContainer>
      <PageTitle>Approvals</PageTitle>
    </HeaderContainer>
  );
};

export default Header;
